import { newClassnamesForUI } from "../tools";
import { Container, Link, i18n, CurrentPortal, Portal, utils } from '@common';
import termsOfUse from '../content/termsOfUse';
import privacyStatement from '../content/privacyStatement';
import fAQ from "../content/FAQ";
import fAQAdmin from "../content/FAQAdmin";

const mainClass = newClassnamesForUI('main-layout');
export default class Footer extends R.Component {
    doHandleYear() {
        let myDate = new Date();
        let year = myDate.getFullYear();
        return year;
    }
    render() {
        const { id, className } = this.props;
        switch (CurrentPortal.type) {
            case Portal.Admin:
                return (
                    <div id={id} className={mainClass('-footer', className)} style={{ margin: "0 40px calc(20px - var(--padding-m))", paddingLeft: 0, paddingRight: 0 }}>
                        <div className={mainClass('-footer-flex', "flex-row")}>
                            <div className="flex-item">
                                <div className={mainClass('-footer-links')}>
                                    <Link className="margin-right-xs" to="/admin/FAQ" target="_blank">{i18n.get('Common_Footer_FAQ_Entry')}</Link>
                                </div>
                                <div className="mobile-hidden margin-top-s">{i18n.get('Common_Footer_BestBrowser_Message')}</div>
                            </div>
                            <div className={mainClass('-footer-right')}>
                                <div>{i18n.get('Common_Footer_AllRights_Message', this.doHandleYear())}</div>
                                <div className="margin-top-s">{i18n.get('Common_Footer_LastUpdatedDate_Entry', utils.getBuildDate())}</div>
                            </div>
                        </div>
                    </div>
                );
            case Portal.Student:
                return (
                    <div id={id} className={mainClass('-footer', className)} style={{ margin: "0 40px calc(50px - var(--padding-m))", paddingLeft: 0, paddingRight: 0 }}>
                        <div className={mainClass('-footer-flex', "flex-row")}>
                            <div className="flex-item">
                                <div className={mainClass('-footer-links')}>
                                    <a className="margin-right-xs" href="https://www.tech.gov.sg/report_vulnerability" target="_blank" rel="noreferrer">{i18n.get('Common_Footer_ReportVulnerability_Entry')}</a>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs margin-right-xs" to="/student/privacystatement" target="_blank">{i18n.get('Common_Footer_PrivacyStatement_Entry')}</Link>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs" to="/student/termsofuse" target="_blank">{i18n.get('Common_Footer_TermsOfUse_Entry')}</Link>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <a className="margin-left-xs margin-right-xs" href="https://step.polite.edu.sg/student/contact" target="_blank" rel="noreferrer">{i18n.get('Common_Footer_Contact_Entry')}</a>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs margin-right-xs" to="/student/FAQ" target="_blank">{i18n.get('Common_Footer_FAQ_Entry')}</Link>
                                </div>
                                <div className="mobile-hidden margin-top-s">{i18n.get('Common_Footer_BestBrowser_Message')}</div>
                            </div>
                            <div className={mainClass('-footer-right')}>
                                <div>{i18n.get('Common_Footer_AllRights_Message', this.doHandleYear())}</div>
                                <div className="margin-top-s">{i18n.get('Common_Footer_LastUpdatedDate_Entry', utils.getBuildDate())}</div>
                            </div>
                        </div>
                    </div>
                );
            case Portal.CIS:
                return (
                    <div id={id} className={mainClass('-footer', className)} style={{ margin: "0 40px calc(20px - var(--padding-m))", paddingLeft: 0, paddingRight: 0 }}>
                        <div className={mainClass('-footer-flex', "flex-row")}>
                            <div className="flex-item">
                                <div className={mainClass('-footer-links')}>
                                    <a className="margin-right-xs" href="https://www.tech.gov.sg/report_vulnerability" target="_blank" rel="noreferrer">{i18n.get('Common_Footer_ReportVulnerability_Entry')}</a>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs margin-right-xs" to="/oauth/privacystatement" target="_blank">{i18n.get('Common_Footer_PrivacyStatement_Entry')}</Link>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs" to="/oauth/termsofuse" target="_blank">{i18n.get('Common_Footer_TermsOfUse_Entry')}</Link>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <a className="margin-left-xs margin-right-xs" href="https://step.polite.edu.sg/student/contact" target="_blank" rel="noreferrer">{i18n.get('Common_Footer_Contact_Entry')}</a>
                                    <div className="margin-bottom-xs mobile-visible"></div>
                                    <span>|</span>
                                    <Link className="margin-left-xs margin-right-xs" to="/oauth/FAQ" target="_blank">{i18n.get('Common_Footer_FAQ_Entry')}</Link>
                                </div>
                                <div className="mobile-hidden margin-top-s">{i18n.get('Common_Footer_BestBrowser_Message')}</div>
                            </div>
                            <div className={mainClass('-footer-right')}>
                                <div>{i18n.get('Common_Footer_AllRights_Message', this.doHandleYear())}</div>
                                <div className="margin-top-s">{i18n.get('Common_Footer_LastUpdatedDate_Entry', utils.getBuildDate())}</div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }
}

export class PrivacyStatement extends R.Component {
    render() {
        return (
            <Container>
                <Container.Back back={{ text: i18n.get('Common_Footer_PrivacyStatement_Entry'), url: '/student' }} />
                <Container.Section className={mainClass('-footer-html')}>
                    <R.HtmlPurify content={privacyStatement.replaceAll('>\n', '>').replaceAll('\n<', '<')} />
                </Container.Section>
            </Container>
        );
    }
}

export class TermsOfUse extends R.Component {
    render() {
        return (
            <Container>
                <Container.Back back={{ text: i18n.get('Common_Footer_TermsOfUse_Entry'), url: '/student' }} />
                <Container.Section className={mainClass('-footer-html')}>
                    <R.HtmlPurify content={termsOfUse.replaceAll('>\n', '>').replaceAll('\n<', '<')} />
                </Container.Section>
            </Container>
        );
    }
}

export class FAQ extends R.Component {
    render() {
        return (
            <Container>
                <Container.Back back={{ text: i18n.get('Common_Footer_FAQ_Entry'), url: 'student' }} />
                <Container.Section className={mainClass('-footer-html')}>
                    <R.HtmlPurify content={fAQ.replaceAll('>\n', '>').replaceAll('\n<', '<')} />
                </Container.Section>
            </Container>
        );
    }
}

export class FAQAdmin extends R.Component {
    render() {
        return (
            <Container>
                {/* <Container.Back back={{ text: i18n.get('Common_Footer_FAQ_Entry'), url: `${CurrentPortal.type === Portal.Admin ? 'admin' : 'student'}` }} /> */}
                <Container.Section className={mainClass('-footer-html')}>
                    <R.HtmlPurify content={fAQAdmin.replaceAll('>\n', '>').replaceAll('\n<', '<')} />
                </Container.Section>
            </Container>
        );
    }
}
